// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.listingconversation.RentalManagerUserListingConversationWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing,
  RentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing_Path,
  RentalManagerUserListingConversationWebApiHandler_updateStatus,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  ListingAlias,
  MultiBrandSupportConversationStatusUpdateRequestDto,
  RentalManagerUserListingConversationGetConversationCountsForListingResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface GetConversationCountsForListingParams {
  calculateInRealTime?: boolean;
  listingAlias: ListingAlias;
}

export type RentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing_Options = UseQueryOptions<
  RentalManagerUserListingConversationGetConversationCountsForListingResponseWebDto,
  unknown,
  RentalManagerUserListingConversationGetConversationCountsForListingResponseWebDto,
  readonly [string, GetConversationCountsForListingParams]
>;

const RentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing_GetKey = (
  getParams: GetConversationCountsForListingParams,
) => [RentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing_Path, getParams] as const;

export const RentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing_queryOptions = (
  getParams: GetConversationCountsForListingParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing_GetKey(getParams),
    queryFn: () =>
      RentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get cached conversation counts for the last 90 days for this listing
 */
export const useRentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing = (
  getParams: GetConversationCountsForListingParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing.getKey =
  RentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing_GetKey;

export interface RentalManagerUserListingConversationWebApiHandler_updateStatus_Args {
  postData: MultiBrandSupportConversationStatusUpdateRequestDto;
}

export type RentalManagerUserListingConversationWebApiHandler_updateStatus_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserListingConversationWebApiHandler_updateStatus_Args
>;

/**
 * Update status of a conversation
 */
export const useRentalManagerUserListingConversationWebApiHandler_updateStatus = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserListingConversationWebApiHandler_updateStatus_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserListingConversationWebApiHandler_updateStatus_Args) =>
      RentalManagerUserListingConversationWebApiHandler_updateStatus(args.postData, httpClient),
  });
};
